module.exports = __webpack_public_path__ + "a1c31972b103ab715af20f51204b4bae.MP3";